<template>
  <section class="content-plans-register">
    <Breadcrumb :links="links" :data="this.dataProps" />
    <form class="content-plans-register-form" @submit.prevent="handleSubmit()">
      <div class="row">
        <div class="col-12">
          <div class="content-input-default">
            <input
              type="text"
              name="name"
              v-model="plan.name"
              value=""
              placeholder="Nome*"
              required
            />
          </div>
        </div>
        <div class="col-12">
          <div class="content-input-default">
            <input
              type="text"
              name="price"
              v-mask="'##?#?#,##'"
              :value="plan.price"
              inputmode="numeric"
              placeholder="Preço*"
              required
              @input="formatPrice"
            />
            <span>Somente números. Ex: 59,90</span>
          </div>
        </div>
        <div class="col-12">
          <div class="content-input-default-select">
            <label for="period">Qual o tipo do plano?</label>
            <div class="position-relative">
              <select
                id="type-plan"
                v-model="plan.type_plan"
                aria-label="period-consultation"
                :class="{
                  'content-input-default-select--active':
                    plan.type_plan !== null,
                }"
                required
              >
                <option :value="null" selected disabled>
                  Selecione o tipo de plano*
                </option>
                <option name="platform" value="platform">Plataforma</option>
                <option
                  name="platform-consultation"
                  value="platform-consultation"
                >
                  Plataforma + Psicólogos
                </option>
              </select>
              <svg
                width="7"
                height="12"
                viewBox="0 0 7 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <mask
                  id="mask0_35_1490"
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="7"
                  height="12"
                  style="mask-type: luminance"
                >
                  <path
                    d="M0.920705 12H7L7 0.543873H0.920705L0.920705 12Z"
                    fill="white"
                  ></path>
                </mask>
                <g mask="url(#mask0_35_1490)">
                  <path
                    d="M6.77741 6.84966C7.0742 6.53013 7.0742 6.01118 6.77741 5.69165L2.21883 0.78349C1.92207 0.463963 1.44008 0.463963 1.14331 0.78349C0.846487 1.10307 0.846487 1.62196 1.14331 1.94155L5.16529 6.27191L1.14569 10.6023C0.848868 10.9219 0.848868 11.4408 1.14569 11.7603C1.44246 12.0799 1.92445 12.0799 2.22121 11.7603L6.77979 6.85221L6.77741 6.84966Z"
                    fill="black"
                  ></path>
                </g>
              </svg>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="content-input-default">
            <input
              type="text"
              name="number_of_collaborators"
              v-model="plan.number_of_collaborators"
              v-mask="'#####'"
              value=""
              placeholder="Número máximo de colaboradores permitido"
              required
            />
            <span>Somente números. Ex: 100</span>
          </div>
        </div>
        <template v-if="plan.type_plan === 'platform-consultation'">
          <div class="col-12">
            <div class="content-input-default">
              <input
                type="text"
                name="number_of_consultations"
                v-model="plan.number_of_consultations"
                v-mask="'####'"
                value=""
                placeholder="Número de consultas com base no período*"
                required
              />
              <span>Somente números. Ex: 4</span>
            </div>
          </div>
          <div class="col-12">
            <div class="content-input-default-select">
              <label for="period">Período:</label>
              <div class="position-relative">
                <select
                  id="period"
                  v-model="plan.period"
                  aria-label="period-consultation"
                  :class="{
                    'content-input-default-select--active':
                      plan.period !== null,
                  }"
                  required
                >
                  <option :value="null" selected disabled>
                    Período das consultas*
                  </option>
                  <option name="month" value="mensal">Mensal</option>
                  <option name="semi-annual" value="semestral">
                    Semestral
                  </option>
                  <option name="year" value="anual">Anual</option>
                </select>
                <svg
                  width="7"
                  height="12"
                  viewBox="0 0 7 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <mask
                    id="mask0_35_1490"
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="7"
                    height="12"
                    style="mask-type: luminance"
                  >
                    <path
                      d="M0.920705 12H7L7 0.543873H0.920705L0.920705 12Z"
                      fill="white"
                    ></path>
                  </mask>
                  <g mask="url(#mask0_35_1490)">
                    <path
                      d="M6.77741 6.84966C7.0742 6.53013 7.0742 6.01118 6.77741 5.69165L2.21883 0.78349C1.92207 0.463963 1.44008 0.463963 1.14331 0.78349C0.846487 1.10307 0.846487 1.62196 1.14331 1.94155L5.16529 6.27191L1.14569 10.6023C0.848868 10.9219 0.848868 11.4408 1.14569 11.7603C1.44246 12.0799 1.92445 12.0799 2.22121 11.7603L6.77979 6.85221L6.77741 6.84966Z"
                      fill="black"
                    ></path>
                  </g>
                </svg>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="content-input-default">
              <textarea
                type="text"
                name="benefits"
                v-model="plan.benefits"
                value=""
                placeholder="Benefícios do plano*"
                required
              ></textarea>
            </div>
          </div>
        </template>
        <div class="col-12">
          <button class="btn-green">Salvar</button>
        </div>
      </div>
    </form>
  </section>
</template>

<script>
import Breadcrumb from "@/components/breadcrumb/Index";
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      links: [
        {
          name: "Empresas",
          routerName: "Company",
        },
        {
          name: "Registrar Plano",
          routerName: "RegisterCompanyPlans",
        },
      ],
      plan: {
        name: "",
        price: "",
        benefits: null,
        number_of_collaborators: null,
        number_of_consultations: null,
        period: null,
        type_plan: null,
      },
      planParams: this.$route.params,
      dataProps: { module: "Company" },
    };
  },
  computed: {
    ...mapGetters({
      user: "User/user",
      plansData: "Company/plans",
    }),
  },
  components: {
    Breadcrumb,
  },
  methods: {
    ...mapActions("Company", [
      "registerPlan",
      "consultPlans",
      "setDataDefault",
    ]),
    async handleSubmit() {
      let message = this.plan?.id
        ? "Plano editado com sucesso!"
        : "Plano cadastrado com sucesso!";

      await this.registerPlan(this.plan);
      this.$router.push({ name: "ListCompanyPlans" });
      this.$swal.fire({
        icon: "success",
        html: message,
      });
    },
    formatPrice(event) {
      const numbers = event.target.value.replace(/\D/g, "").slice(0, 6);

      if (!numbers) {
        this.plan.price = "";
        event.target.value = "";
        return;
      }

      const numberFormatted = (Number(numbers) / 100)
        .toFixed(2)
        .replace(".", ",");

      this.plan.price = numberFormatted;
      event.target.value = numberFormatted;
    },
  },
  async mounted() {
    if (this.planParams && Object.keys(this.planParams).length > 0) {
      await this.consultPlans(this.planParams);
      this.dataProps = {
        name: this.plansData.name,
        id: this.planParams.id,
        module: "Company",
        type: "Plan",
      };
      this.plan = this.plansData;
      this.links[1].name = this.plan.name;
    }
  },
};
</script>

<style lang="scss" scoped>
.content-plans-register {
  padding-bottom: 50px;
}
.content-input-default {
  textarea {
    min-height: 250px;
  }
}
.btn-green {
  margin-top: 100px;
  @media (max-width: 991px) {
    margin-top: 50px;
  }
}
</style>
